// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2I2zl","header":"PatientQuestionnaire_header__2HgGZ","info":"PatientQuestionnaire_info__3OmJQ"};